class Cache {
    constructor(name) {
        this._name = name;
        this._cache = this.loadCache();
    }

    loadCache(){
        const text = localStorage.getItem("cache_"+this._name);
        return text ? JSON.parse(text) : [];
    }

    saveCache(){
        localStorage.setItem("cache_"+this._name,JSON.stringify(this._cache));
    }

    put(key,item){
        key = key.trim();

        if(!key)
            return null;

        if(this.get(key)){
            this._cache.find(item=> item.key === key ).item = item
            return;
        }

        if(this._cache.length >= 10)
            this._cache.shift()

        this._cache.push({time:+Date.now(),item,key})
        this.saveCache();
    }

    get(key){
        key = key.trim();

        const item = this._cache.find(item => item.key === key);

        if(!item)
            return null;

        if(+Date.now() - item.time > 1000*60*60*24){
            this.remove(key);
            console.log("Cache item "+key+" expired");
            return null;
        }

        return item.item;
    }

    remove(key){
        const index = this._cache.findIndex(item => item.key === key);
        if(index > -1)
            this._cache.splice(index,1);
        this.saveCache();
    }
}

module.exports = Cache